import { Box } from "@mui/material";

import { Filter } from "../../common-components/Dropdowns/Dropdowns";

const EmergencyFilter = ({onEmergencyChange, reset}) => {

    const options = [
        { id: "1", name: "Пожар" },
        { id: "2", name: "Травма" },
        { id: "3", name: "Отключение электроэнергии" },
        { id: "4", name: "Обрушение" },
        { id: "5", name: "Несчастный случай" },
        { id: "6", name: "Застревание" },
        { id: "7", name: "Заболевание" },
        { id: "8", name: "Затопление" },
        { id: "9", name: "ДТП" },
        { id: "10", name: "Загазованность" },
        { id: "11", name: "Взрыв" },
        { id: "12", name: "Обеспечение противопожарной" },
        { id: "13", name: "Поиск людей" },
        { id: "14", name: "Открытый фонтан" },
        { id: "15", name: "Розлив" },
        { id: "16", name: "Иное" }
    ]

    const handleBranchChange = (option) => {
        onEmergencyChange(option.id);
    }

    return (
        <Box className={"branch_filter"}>
            <Filter options={options} propertyLabel={"Выберите аварию"} onOptionClick={handleBranchChange} reset={reset}/>
        </Box>
    )
}

export default EmergencyFilter;